import { render, staticRenderFns } from "./SchoolAwayDetailPageTable.vue?vue&type=template&id=412b6b92&scoped=true&"
import script from "./SchoolAwayDetailPageTable.vue?vue&type=script&lang=js&"
export * from "./SchoolAwayDetailPageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412b6b92",
  null
  
)

export default component.exports